import { IClient } from "../interfaces/client";
import api from "./api";

const pageSize = 5;


export async function fetchClient(
  pageNumber: number,
  search: string
): Promise<any> {
  let url = "";
  const params: any = { page: pageNumber, pageSize };

  if (search.trim()) {
    url = `/Client/searchClientbyname`;
    params.name = search;
  } else {
    url = `/Client/paged`;
  }

  const response = await api.get(url, { params });
  return response;
}

export async function saveUser(
  data: IClient,
  editando: boolean,
  userId?: number
) {
  const dataToSend = { ...data, foto: null, userId: 1 };
  if (editando && userId) {
    dataToSend.id = userId;
    return api.put(`Client/`, dataToSend);
  } else {
    return api.post(`Client/`, dataToSend);
  }
}

export async function deleteUser(userId: number) {
  return api.delete(`Client/${userId}`);
}

export async function searchClientByName(query: string) {
  const response = await api.get(`/Client/ListClientsName?name=${query}`);
  return response.data || [];
}

export async function searchProductsByClient(id: number) {
  const response = await api.get(`/Product/ListProductByClient?IdClient=${id}`);
  return response.data || [];
}